import { Switch } from "react-router-dom";

import DashFinanceiro from "../../pages/dashboard/DashFinanceiro";
import DashGeral from "../../pages/dashboard/DashGeral";
import { DashBoardContextProvider } from "../../pages/dashboard/contexts/DashBoardContext";
import Route from "../Route";

export default function Dashboard() {
  return (
    <>
      <DashBoardContextProvider>
        <Switch>
          <Route path="/dashboard/financeiro" component={DashFinanceiro} />
          <Route path="/dashboard" component={DashGeral} />
        </Switch>
      </DashBoardContextProvider>
    </>
  );
}
